import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription, filter, first } from 'rxjs';
import { StoresService } from '../../../core/services/stores.service';

@Component({
  selector: 'app-cancel-subscription-modal',
  templateUrl: './cancel-subscription-modal.component.html',
  styleUrls: ['./cancel-subscription-modal.component.scss']
})
export class CancelSubscriptionModalComponent {

  constructor(private bsModalRef: BsModalRef, private router: Router) { }

  close() {
    this.bsModalRef.hide();
  }

  cancelSubscription() {
    this.bsModalRef.hide();
    this.router.navigateByUrl(`/cancel-subscription`);
  }
}
